module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA4SURBVHgBncxJDgAgEAJBns7PMUY9mOgscKYLkih/xJyJrPisidxxE3nHRSSOE6QWfxDC2UYYfQZp8BcAHV6DkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icn-dropdown-white.png
// module id = I5m+
// module chunks = 0